/**
 * FE-24: Admin Suggestions API layer.
 * Maps to: GET /admin/suggestions
 */

import { apiFetch } from "./client";

// ─── Types ───

export type SuggestionLevel = "P1" | "P2" | "P3";
export type SuggestionCategory = "ops" | "product";

export type Suggestion = {
  readonly id: string;
  readonly level: SuggestionLevel;
  readonly category: SuggestionCategory;
  readonly title: string;
  readonly detail: string;
  readonly link_to: string;
};

export type SuggestionsResult = {
  readonly ops: ReadonlyArray<Suggestion>;
  readonly product: ReadonlyArray<Suggestion>;
};

// ─── API Call ───

export async function fetchSuggestions(): Promise<SuggestionsResult> {
  const res = await apiFetch<{ data: SuggestionsResult }>("/admin/suggestions");
  return res.data;
}
